import { Map, fromJS, getIn } from 'immutable';

import { createReducer } from '../utils/helpers';
import { LOGIN_SUCCESS } from '../auth/types';

const initialState = fromJS({
  flags: {},
});

const featureFlagReducerObject = {
  [LOGIN_SUCCESS]: (state, action) => {
    const features = Map(
      getIn(
        action,
        ['payload', 'tokenPayload', `${window._env_.JWT_DATA_PREFIX}/app_metadata`, 'features'],
        Map(),
      ),
    );

    // If `MOCK_FEATURE_FLAGS` is set on the environment
    // we replace the real feature flags with the mocked ones
    const mockFeaturesFlags =
      window._env_.MOCK_FEATURE_FLAGS !== undefined
        ? JSON.parse(window._env_.MOCK_FEATURE_FLAGS)
        : false;

    return state.set('flags', mockFeaturesFlags || features);
  },
};

export default createReducer(initialState, featureFlagReducerObject);
